import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntCompany } from "../../../models/chemicalization/company";
import { EntCompanyFilter } from "../../../models/filters/companyFilter";
import { Paths } from "../../../paths";

export const companyApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getCompanyList: builder.query<ResponseDataGet<EntCompany>, EntCompanyFilter>({
	  query: (filter) => ({
		url: `${ Paths.chemicalization.company }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getCompanyById: builder.query<ResponseDataTest<EntCompany>, number>({
	  query: (id) => ({
		url: `${ Paths.chemicalization.company }/${ id }`,
		method: 'GET'
	  })
	}),
	addCompany: builder.mutation<ResponseDataTest<EntCompany>, EntCompany>({
	  query: (body) => ({
		url: `${ Paths.chemicalization.company }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editCompany: builder.mutation<ResponseDataTest<EntCompany>, EntCompany>({
	  query: (body,) => ({
		url: `${ Paths.chemicalization.company }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteCompany: builder.mutation<ResponseDataTest<EntCompany>, number>({
	  query: (id) => ({
		url: `${ Paths.chemicalization.company }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddCompanyMutation,
  useDeleteCompanyMutation,
  useEditCompanyMutation,
  useLazyGetCompanyListQuery
} = companyApi;
